<template>
  <div class="footer">
    <div class="content">
      <div class="msg-left">
        <div class="msg">
          <strong>关于品农</strong>
          <router-link
            :to="{
              name: ylStatus ? 'about_yl' : 'about',
              query: { routerPath: 'qyjj' }
            }"
          >
            <p>企业简介</p>
          </router-link>
          <router-link
            :to="{
              name: ylStatus ? 'about_yl' : 'about',
              query: { routerPath: 'ldtd' }
            }"
          >
            <p>领导团队</p>
          </router-link>
          <router-link
            :to="{
              name: ylStatus ? 'about_yl' : 'about',
              query: { routerPath: 'zzjg' }
            }"
          >
            <p>组织架构</p>
          </router-link>
          <router-link
            :to="{
              name: ylStatus ? 'about_yl' : 'about',
              query: { routerPath: 'fzlc' }
            }"
          >
            <p>发展历程</p>
          </router-link>
          <router-link
            :to="{
              name: ylStatus ? 'about_yl' : 'about',
              query: { routerPath: 'qyry' }
            }"
          >
            <p>企业荣誉</p>
          </router-link>
        </div>
        <div class="msg">
          <strong>企业文化</strong>

          <router-link
            :to="{
              name: ylStatus ? 'culture_yl' : 'culture',
              query: { routerPath: 'pnwh' }
            }"
          >
            <p>品农文化</p>
          </router-link>
          <router-link
            :to="{
              name: ylStatus ? 'culture_yl' : 'culture',
              query: { routerPath: 'pnsh' }
            }"
          >
            <p>品农生活</p>
          </router-link>
        </div>
        <div class="msg">
          <strong>新闻聚焦</strong>
          <router-link
            :to="{
              name: ylStatus ? 'news_yl' : 'news',
              query: { routerPath: 'qyxw' }
            }"
          >
            <p>企业新闻</p>
          </router-link>
          <router-link
            :to="{
              name: ylStatus ? 'news_yl' : 'news',
              query: { routerPath: 'hydt' }
            }"
          >
            <p>行业动态</p>
          </router-link>
          <router-link
            :to="{
              name: ylStatus ? 'news_yl' : 'news',
              query: { routerPath: 'hzxw' }
            }"
          >
            <p>伙伴频道</p>
          </router-link>
        </div>
        <div class="msg">
          <strong>业务专区</strong>
          <router-link
            :to="{
              name: ylStatus ? 'business_yl' : 'business',
              query: { routerPath: 'hzhb' }
            }"
          >
            <p>合作伙伴</p>
          </router-link>
          <router-link
            :to="{
              name: ylStatus ? 'business_yl' : 'business',
              query: { routerPath: 'city' }
            }"
          >
            <p>业务范围</p>
          </router-link>
          <router-link
            :to="{
              name: ylStatus ? 'business_yl' : 'business',
              query: { routerPath: 'qyys' }
            }"
          >
            <p>企业优势</p>
          </router-link>
        </div>
        <div class="msg">
          <strong>人才招聘</strong>
          <router-link :to="{ name: ylStatus ? 'recruit_yl' : 'recruit' }">
            <p>集团招聘</p>
            <p>子公司招聘</p>
          </router-link>
        </div>
        <div class="msg">
          <strong>联系我们</strong>
          <router-link
            :to="{ name: ylStatus ? 'connection_yl' : 'connection' }"
          >
            <p>公司地址</p>
            <p>在线留言</p>
          </router-link>
        </div>
      </div>
      <div class="msg-right">
        <div>
          <div class="hot-tel">
            <p>服务热线 Service Hotline</p>
            <!-- <img src="@image/telnum.png" alt /> -->
            <strong>400-800-7969</strong>
          </div>
          <div class="hot-tel mt-20">
            <p>总部地址：</p>
            <p>武汉市武昌区武珞路帝斯曼国际中心25层</p>
          </div>
        </div>
        <div class="ml-30">
          <img alt="公众号" src="@image/erweima1.png" />
          <p class="mt-10">扫一扫，关注公众号</p>
        </div>
      </div>
    </div>

    <div class="border"></div>
    <p class="bottom">
      Copyright © 2016-{{ yearDate }} 湖北品农商用车服务有限公司.
      <a @click="jumpWeb">鄂ICP备15018863号-1</a>
      . All Rights Reserved.
    </p>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      yearDate: new Date().getFullYear(),
      ylStatus: this.$store.getters.urlStatus
    }
  },
  methods: {
    jumpWeb() {
      window.open('http://www.beian.miit.gov.cn/')
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background: #013165;
  height: 330px;
  padding-top: 50px;
  strong {
    color: rgba(255, 255, 255, 1);
    font-size: 30px;
    font-weight: 400;
  }
  .content {
    display: flex;
    width: 85%;
    margin: auto;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    .msg-left {
      display: flex;
      padding-right: 50px;
      border-right: 1px solid #305680;
      flex: 1;
      justify-content: space-between;
      flex-flow: nowrap;
      white-space: nowrap;
      .msg {
        margin-right: 50px;
        strong {
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
        p {
          color: #9a9a9a;
          padding: 5px;
          // cursor: pointer;
        }
      }
    }
    .msg-right {
      text-align: start;
      text-align: initial;
      display: flex;
      color: #fff;
      .mt-10 {
        white-space: nowrap;
      }
      .ml-30 {
        img {
          width: 117px;
          height: 117px;
        }
      }

      .hot-tel {
        padding: 0 20px 8px 30px;
        .tel {
          font-size: 30px;
          white-space: nowrap;
        }
        strong {
          font-size: 24px;
          padding: 0 8px 8px 8px;
        }
        p {
          padding: 0 8px 8px 8px;
        }
        img {
          margin-left: 8px;
        }
      }
    }
  }
  .border {
    width: 85%;
    margin: 70px auto 30px auto;
    border: 1px solid rgba(236, 236, 236, 1);
    opacity: 0.2;
  }
  .bottom {
    color: #aec0dc;
    text-align: center;
    a {
      color: #aec0dc;
    }
    a:hover {
      cursor: pointer;
      color: #fff;
    }
  }
}
</style>
